module.exports = __webpack_public_path__ + "assets/ic_kakao2.724cc71f.svg";